import { ClayInput } from '@clayui/form';
import BaseWrapper from "../BaseWrapper";
import React, { useCallback } from "react";
import { Controller, useFormContext } from 'react-hook-form';

type FormInputZipCodeProps = {
    name: string;
    label?: string;
    groupClassName?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
};

export function FormInputZipCode(props: FormInputZipCodeProps) {
    const { formState } = useFormContext();

    const formatZipCode = useCallback((value: string): string => {
        const digits = value.replace(/\D/g, '');

        if (digits.length <= 2) {
            return digits;
        } else {
            return `${digits.slice(0, 2)}-${digits.slice(2, 5)}`;
        }
    }, []);

    return (
        <Controller
            name={props.name}
            render={({ field, fieldState }) => (
                <BaseWrapper
                    error={fieldState?.error?.message}
                    id={props.name}
                    label={props.label}
                    required={props.required}
                    groupClassName={props.groupClassName}
                >
                    <ClayInput
                        id={props.name}
                        name={props.name}
                        value={field.value ?? ''}
                        placeholder={props.placeholder ?? 'XX-XXX'}
                        className='text-ellipsis'
                        maxLength={6}
                        disabled={props.disabled || formState.isLoading}
                        onChange={(e) => {
                            const formattedValue = formatZipCode(e.target.value);
                            field.onChange(formattedValue);
                        }}
                        required={props.required}
                    />
                </BaseWrapper>
            )}
        />
    );
}
